(function () {
    'use strict';

    angular
        .module('ipmApp')
        .directive('psychIntakePreviousTreatmentComponent', psychIntakePreviousTreatmentComponent);

    psychIntakePreviousTreatmentComponent.$inject = [];

    function psychIntakePreviousTreatmentComponent() {
        var directive = {
            restrict: 'EA',
            scope: {
                workflow: '='
            },
            link: linkFunc,
            controller: DirectivePsychIntakePreviousTreatmentController,
            templateUrl: 'app/psych-intake/workflow/partial/directive/previous-treatment.directive.html',
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, element, attrs) {

        }
    }

    DirectivePsychIntakePreviousTreatmentController.$inject = ['$scope', '$stateParams', '$element'];
    function DirectivePsychIntakePreviousTreatmentController($scope, $stateParams, $element) {
        var vm = this;
        
        function init() {
        }

        init();

        vm.disabledCheck = function(item) {
            if ($scope.vm.workflow.answer && $scope.vm.workflow.answer.followingTreatmentSelected) {
                var selected = $scope.vm.workflow.answer.followingTreatmentSelected;
	            if (item === 'NONE') {
	                var symptoms = ['PHYSICAL_THERAPY', 'AQUATIC_THERAPY', 'CHIROPRACTIC', 'ACUPUNCTURE', 'TENS_HWAVE', 'INJECTIONS', 'GROUP_PSYCHOTHERAPY',
		                'INDIVIDUAL_PSYCHOTHERAPY', 'FAMILY_THERAPY', 'MEDICATION_PSYCHIATRY', 'INPATIENT_CARE', 'SCS_EVALUATION_TRIAL', 'OTHER'];
	                return symptoms.some(function(symptom) {
	                    return selected[symptom];
	                });
	            } else {
	                return selected['NONE'];
	            }
            } else {
            	return false;
            }
        }
    }
})();
